module.exports = __webpack_public_path__ + "img/dcu30-char-2.b02a12c4.png";